export enum TariffTypeEnum {
  Region,
  Country,
  HSCode
}
